// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type HeaderState = Readonly<{
    isSticky: boolean;
    mobileSearch: boolean;
    notificationBar: boolean;
    stickyMenu: boolean;
    secondaryNavigationItems: any[];
}>;

const initialHeaderState: HeaderState = {
    isSticky: false,
    mobileSearch: false,
    notificationBar: true,
    stickyMenu: false,
    secondaryNavigationItems: [],
};

const reducer = {
    "xHeader/isSticky": (draft: Draft<HeaderState>, action: { isSticky: boolean }) => {
        draft.isSticky = action.isSticky;
    },
    "xHeader/mobileSearch": (draft: Draft<HeaderState>, action: { mobileSearch: boolean }) => {
        draft.mobileSearch = action.mobileSearch;
    },
    "xHeader/notificationBar": (draft: Draft<HeaderState>, action: { notificationBar: boolean }) => {
        draft.notificationBar = action.notificationBar;
    },
    "xHeader/stickyMenu": (draft: Draft<HeaderState>, action: { stickyMenu: boolean }) => {
        draft.stickyMenu = action.stickyMenu;
    },
    "xHeader/setSecondaryNavigationItems": (draft: Draft<HeaderState>, action: { secondaryNavigationItems: any[] }) => {
        draft.secondaryNavigationItems = action.secondaryNavigationItems;
    },
};

const xHeader = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xHeader = xHeader;

export type xHeaderState = {
    xHeader: HeaderState;
};

type xHeaderReducers = {
    isSticky: typeof xHeader;
    mobileSearch: typeof xHeader;
    notificationBar: typeof xHeader;
    stickyMenu: typeof xHeader;
};

export type xHeaderActions = Parameters<xHeaderReducers[keyof xHeaderReducers]>[1] | AnyAction;
